function getSortItem(item, by) {
    return `${typeof by === "function" ? by(item) : item[by]}`;
}
function sortBy({ dir, by }) {
    return (a, b) => {
        const first = getSortItem(a, by);
        const second = getSortItem(b, by);
        if (first === "undefined" || first === "null")
            return 1;
        if (second === "undefined" || second == "null")
            return -1;
        if (dir === "desc") {
            return second.localeCompare(first, undefined, {
                numeric: true,
            });
        }
        return first.localeCompare(second, undefined, {
            numeric: true,
        });
    };
}
export function sortTasks(tasks, config) {
    if (config.tree) {
        for (const task of tasks) {
            if (task.children?.length)
                sortTasks(task.children, config);
        }
    }
    tasks.sort(sortBy(config));
}
//# sourceMappingURL=sort.js.map